import { css } from "@stubhub/broadway-foundation/css";

export const cardStyle = css({
  display: "flex",
  flexDirection: "column",
  columnGap: "primitives.200",
  rowGap: "primitives.200",
  paddingBlock: "primitives.300",
  paddingInline: "primitives.300",
  marginBlockStart: "primitives.200",
  marginBlockEnd: "primitives.200",
  backgroundColor: "bg.surface",
  borderBlockWidth: "thin",
  borderInlineWidth: "thin",
  borderBlockColor: "border",
  borderInlineColor: "border",
  borderStartRadius: "element.default",
  borderEndRadius: "element.default",
  boxShadow: "[0px 0px 10px rgba(0,0,0,0.10)]",
});

export const headlineStyle = css({
  fontWeight: "semibold",
  fontSize: "primitives.400",
  lineHeight: "primitives.500",
  color: "text",
});

export const bottomRowStyle = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  columnGap: "primitives.200",
  rowGap: "primitives.200",
});

export const appInfoStyle = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  flexShrink: 1,
  minWidth: "primitives.0",
});

export const appLogoStyle = css({
  width: "primitives.500",
  height: "primitives.500",
  borderStartRadius: "element.small",
  borderEndRadius: "element.small",
  flexShrink: 0,
});

export const appNameRatingStyle = css({
  display: "flex",
  flexDirection: "column",
  columnGap: "primitives.25",
  rowGap: "primitives.25",
  minWidth: "primitives.0",
});

export const appNameStyle = css({
  fontWeight: "medium",
  fontSize: "primitives.350",
  lineHeight: "primitives.500",
  color: "text.subtle",
  overflowX: "hidden",
  overflowY: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const ratingRowStyle = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: "primitives.50",
  rowGap: "primitives.50",
});

export const ratingScoreStyle = css({
  fontWeight: "medium",
  fontSize: "primitives.350",
  lineHeight: "primitives.500",
  color: "text.subtle",
});

export const ratingStarsStyle = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: "[1px]",
  rowGap: "[1px]",
  color: "[#FFB33F]",
});

export const downloadButtonStyle = css({
  flexShrink: 0,
  whiteSpace: "nowrap",
});
